"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _recommended = require("@/api/recommended");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  props: {
    allProductList: {
      type: Array | String,
      default: function _default() {
        return '';
      }
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      title: '选择app_id，同步icon与banner',
      form: {
        app_id: ''
      },
      rules: {
        app_id: [{
          required: true,
          message: '请选择所属产品app_id',
          trigger: 'blur'
        }]
      }
    };
  },
  watch: {
    dialogVisible: function dialogVisible() {
      this.form.app_id = '';
    }
  },
  methods: {
    onCancel: function onCancel() {
      this.dialogVisible = false;
    },
    submitForm: function submitForm() {
      var _this = this;
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this.handleEvent();
        }
      });
    },
    handleEvent: function handleEvent() {
      var _this2 = this;
      var params = {
        app_id: this.form.app_id
      };
      (0, _recommended.syncIconAndBanner)(params).then(function (_ref) {
        var code = _ref.code,
          data = _ref.data;
        if (code === 200) {
          var _data$msg;
          _this2.$message({
            message: (data === null || data === void 0 ? void 0 : data.msg) || '同步成功',
            type: data !== null && data !== void 0 && (_data$msg = data.msg) !== null && _data$msg !== void 0 && _data$msg.includes('成功') ? 'success' : 'info'
          });
        } else {
          _this2.$message({
            message: (data === null || data === void 0 ? void 0 : data.msg) || '同步失败',
            type: 'error'
          });
        }
        _this2.dialogVisible = false;
      }).catch(function (error) {
        _this2.$message({
          message: '同步失败，请重试',
          type: 'error'
        });
        _this2.dialogVisible = false;
        console.error('同步失败:', error);
      });
    }
  }
};